<template>
  <div v-show="innerVisible" class="deptCompont">
    <div>
      <van-search
        background="#F5F5F5"
        v-model="key"
        @search="onSearch"
        @clear="onClearSearch"
        @input="onSearchInput"
        placeholder="请输入搜索关键词"
      ></van-search>
    </div>
    <div class="slelctList">
      <template v-if="select.length > 0">
        <div
          class="dept-name-box-select"
          v-for="(item, index) in select"
          :key="index"
        >
          <img class="icon-img" src="./dept.png" />
          {{ item.name }}
        </div>
      </template>
      <template v-else>
        <span class="emptyData">暂无选择数据</span>
      </template>
    </div>
    <div v-show="!showSearchRe" class="treeNode">
      <el-tree
        :props="treeProps"
        :load="loadNode"
        :check-strictly="true"
        node-key="id"
        ref="tree"
        @check-change="nodeCheckChange"
        lazy
        show-checkbox
      >
        <div class="custom-tree-node" slot-scope="{ node, data }">
          <div class="dept-name-box">
            <img class="icon-img" src="./dept.png" />
            {{ data.name }}
          </div>
        </div>
      </el-tree>
      <div class="plr15 pt10">
        <van-button class="w100" @click="confirm" type="danger"
          >确认</van-button
        >
      </div>
    </div>
    <div v-show="showSearchRe" class="selectTreeNode">
      <el-tree
        :props="treeProps"
        :data="searchData"
        :check-strictly="true"
        node-key="id"
        ref="searchTree"
        @check-change="nodeCheckChange"
        show-checkbox
      >
        <div class="custom-tree-node" slot-scope="{ node, data }">
          <div class="dept-name-box">
            <img class="icon-img" src="./dept.png" />
            {{ data.name }}
          </div>
        </div>
      </el-tree>
      <div class="plr15 pt10">
        <van-button class="w100" @click="confirm" type="danger"
          >确认</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import url from "./url";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    initList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      treeProps: {
        label: "name",
        children: "child",
        isLeaf: "has_child"
      },
      select: [],
      selectKey: [],
      key: "",
      innerVisible: false,
      searchData: [],
      topDeptId: "",
      showSearchRe: false
    };
  },
  component: {},
  watch: {
    visible: function(val) {
      this.innerVisible = val;
    },
    initList: function(val) {
      this.selectKey = [val[0].id];
      this.select = val;
      this.$refs.tree.setCheckedKeys(this.selectKey);
      this.$refs.searchTree.setCheckedKeys(this.selectKey);
    }
  },
  mounted() {},
  methods: {
    onSearchInput(val) {
      if (val.trim().length === 0) {
        this.searchData = [];
        this.showSearchRe = false;
      }
    },
    onClearSearch() {
      this.searchData = [];
      this.showSearchRe = false;
    },
    onSearch() {
      this.$common
        .http(
          {
            mt: "post",
            url: url.getSearchData,
            data: {
              department_id: 0,
              offset: 0,
              limit: 9999,
              name: this.key,
              type: 1
            }
          },
          undefined
        )
        .then(res => {
          this.showSearchRe = true;
          this.searchData = res.data.data.items || [];
          this.$refs.searchTree.setCheckedKeys(this.selectKey);
        });
    },
    nodeCheckChange(data, isCheck) {
      let id = data.id;
      // debugger;
      // if (isCheck) {
      //   this.selectKey.push(id);
      //   this.select.push(data);
      // } else {
      //   let index = this.selectKey.indexOf(id);
      //   this.selectKey.splice(index, 1);
      //   this.select.splice(index, 1);
      // }
      if (isCheck) {
        this.selectKey = [id];
        this.select = [data];
      } else {
        if (this.selectKey[0] == id) {
          this.selectKey = [];
          this.select = [];
        }
      }
      this.$refs.tree.setCheckedKeys(this.selectKey);
      this.$refs.searchTree.setCheckedKeys(this.selectKey);
    },
    confirm() {
      this.$emit("confirm", this.select, this.selectKey);
    },
    loadNode(node, resolve) {
      if (node.level === 0) {
        this.$common
          .http({
            mt: "post",
            url: url.getDeptTop,
            data: {}
          })
          .then(res => {
            console.log(res.data.data);
            this.topDeptId = res.data.data.id;
            res.data.data.disabled =
              Number(res.data.data.enable_r) === 1 ? false : true;
            return resolve([res.data.data]);
          });
      }
      if (node.level === 1) {
        this.$common
          .http({
            mt: "post",
            url: url.getDeptTop,
            data: {}
          })
          .then(res => {
            console.log(res.data.data);
            res.data.data.child.forEach(item => {
              item.has_child = Number(item.has_child) === 1 ? false : true;
              item.disabled = Number(item.enable_r) === 1 ? false : true;
            });
            return resolve(res.data.data.child);
          });
      }
      if (node.level > 1) {
        console.log(node);
        this.$common
          .http({
            mt: "post",
            url: url.getDept,
            data: {
              department_id: node.data.id
            }
          })
          .then(res => {
            let data = res.data.data || [];
            data.forEach(item => {
              item.has_child = Number(item.has_child) === 1 ? false : true;
              item.disabled = Number(item.enable_r) === 1 ? false : true;
            });
            return resolve(data);
          });
      }
    }
  },
  created() {}
};
</script>
<style lang="less" scope>
.deptCompont {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  overflow: auto;
  z-index: 20;
  background: #f5f5f5;
  font-size: 14px;
  .el-tree {
    height: calc(100vh - 190px);
    overflow: auto;
  }
  .slelctList {
    background: #ffffff;
    display: flex;
    padding: 10px 0px 10px 12px;
    margin-bottom: 12px;
    overflow-x: auto;
    white-space: nowrap;
    height: 58px;
    box-sizing: border-box;
    .emptyData {
      display: inline-block;
      line-height: 38px;
      color: #909399;
      font-size: 14px;
    }
  }
  .dept-name-box-select {
    padding: 5px;
    background: #f5f5f5;
    margin-right: 7px;
    border-radius: 2px;
  }
  .dept-name-box,
  .dept-name-box-select {
    display: flex;
    align-items: center;
  }
  .dept-name-box > img,
  .dept-name-box-select > img {
    width: 28px;
  }
  .van-search__content {
    background-color: #ffffff;
  }
  .el-tree-node__content {
    position: relative;
    height: 44px;
    border-bottom: 1px solid #f5f5f5;
  }
  .el-tree-node__content > label.el-checkbox {
    margin-right: 8px;
    position: absolute;
    left: 12px;
    padding-right: 14px;
    z-index: 100;
  }
  .el-tree-node__content > .el-tree-node__expand-icon {
    padding: 6px;
    margin-left: 30px;
  }

  .el-checkbox__inner {
    width: 20px;
    height: 20px;
  }

  .el-checkbox__inner::after {
    left: 7px;
    top: 3px;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #ee0a24;
    border-color: #ee0a24;
  }

  .el-tree-node__content:hover {
    background-color: #ffffff;
  }
}
</style>
